// extracted by mini-css-extract-plugin
export var text = "_g-0";